
import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import Checkbox from '@material-ui/core/Checkbox';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class DisconnectedDevice extends Component {

    constructor(props) {
        super(props);
        this.state = {
            APIName: "disconnectedDevices",
            APIUser: "",
            APIPass: "",
            MinHoursDisconnected: "",
            EmailsTo: "",
            EmailFrom: "",
            EmailPhone: "",
            loadingDisconnectedDevice: false,
            type: 'password',
            DeviceList: [],
            checkboxOptions: [],
            isAutenticated: true
        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleMinHoursDisconnected = this.handleMinHoursDisconnected.bind(this);
        this.handleEmailsTo = this.handleEmailsTo.bind(this);
        this.handleEmailFrom = this.handleEmailFrom.bind(this);
        this.handleEmailPhone = this.handleEmailPhone.bind(this);
        this.showHide = this.showHide.bind(this);
        this.onChange = this.onChange.bind(this);
        this.SelectedAll = this.SelectedAll.bind(this);
    }

    showHide(e) {
        e.preventDefault();
        e.stopPropagation();
        this.setState({
            type: this.state.type === 'input' ? 'password' : 'input'
        })
    }
    componentDidMount() {

        var DisconnectedDeviceList = this.props.DataDisconnectedDevice;

        var DisconnectedDevice = DisconnectedDeviceList.find(x => x.ALIAS === this.state.APIName);
        var DisconnectedDeviceValue = JSON.parse(DisconnectedDevice.VALUE);
        var UserName = DisconnectedDeviceValue.EasyApiUser === null || DisconnectedDeviceValue.EasyApiUser === undefined ? "" : DisconnectedDeviceValue.EasyApiUser;
        var Pass = DisconnectedDeviceValue.EasyApiPassword === null || DisconnectedDeviceValue.EasyApiPassword === undefined ? "" : DisconnectedDeviceValue.EasyApiPassword;
        var MinHoursDisconnected = DisconnectedDeviceValue.MinHoursDisconnected === null || DisconnectedDeviceValue.MinHoursDisconnected === undefined ? "" : DisconnectedDeviceValue.MinHoursDisconnected;
        var EmailsTo = DisconnectedDeviceValue.EmailsTo === null || DisconnectedDeviceValue.EmailsTo === undefined ? "" : DisconnectedDeviceValue.EmailsTo;
        var EmailFrom = DisconnectedDeviceValue.EmailFrom === null || DisconnectedDeviceValue.EmailFrom === undefined ? "" : DisconnectedDeviceValue.EmailFrom;
        var EmailPhone = DisconnectedDeviceValue.EmailPhone === null || DisconnectedDeviceValue.EmailPhone === undefined ? "" : DisconnectedDeviceValue.EmailPhone;
        var SerialDevices = DisconnectedDeviceValue.SerialDevices;

        var SerialDeviceResult = SerialDevices === null || SerialDevices === undefined || SerialDevices === "" ? [] : SerialDevices.split(",");

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.MinHoursDisconnected = MinHoursDisconnected;
        stateCopy.EmailsTo = EmailsTo;
        stateCopy.EmailFrom = EmailFrom;
        stateCopy.EmailPhone = EmailPhone;
        stateCopy.checkboxOptions = SerialDeviceResult;
        this.setState(stateCopy);

        this.getAllDevices();

        console.log()
    }

    handleApiUser(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);
    }
    handleApiPass(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);
    }
    handleMinHoursDisconnected(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.MinHoursDisconnected = value;
        this.setState(stateCopy);
    }
    handleEmailsTo(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailsTo = value;
        this.setState(stateCopy);
    }
    handleEmailFrom(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailFrom = value;
        this.setState(stateCopy);
    }
    handleEmailPhone(event) {
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.EmailPhone = value;
        this.setState(stateCopy);
    }

    ValidateSaveDisconnectedDevice() {

        // var UserName = this.state.APIUser;
        // var Pass = this.state.APIPass;
        var EmailsTo = this.state.EmailsTo;
        var EmailFrom = this.state.EmailFrom;
        var EmailPhone = this.state.EmailPhone;

        if (EmailsTo === null || EmailsTo === "" || EmailsTo === undefined) {
            toast.error("Emails Alert To field can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (EmailFrom === null || EmailFrom === "" || EmailFrom === undefined) {
            toast.error("Email Alert From field can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }
        if (EmailPhone === null || EmailPhone === "" || EmailPhone === undefined) {
            toast.error("T Support Phone field can not be empty!", {
                className: {
                    opacity: 0.8
                }
            });
            return false;
        }       

        return true;
    }

    getAllDevices() {

        var CompanyCode = this.props.CompanyCode;
        var email = sessionStorage.getItem('email');
        var that = this;

        var DataResult = APIService.getAllDevices(CompanyCode, email);
        DataResult.then(function (data) {
            if(data.statusText === "OK") {
                that.setState({
                    DeviceList: data.data
                });
            }else if(data.data === "NotFound") {
                that.setState({
                    DeviceList: []
                });
                toast.error("User does not have permission for this Company!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {

            that.setState({
                DeviceList: []
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }

    SaveDisconnectedDevice(e) {
        e.preventDefault();
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var EmailsTo = this.state.EmailsTo;
        var EmailFrom = this.state.EmailFrom;
        var EmailPhone = this.state.EmailPhone;
        var MinHoursDisconnected = this.state.MinHoursDisconnected;
        var CheckboxList = this.state.checkboxOptions;
        var CompanyCode = this.props.CompanyCode;
        var SerialDevices = [];

        var DisconnectedDeviceList = this.props.DataDisconnectedDevice;
        var DisconnectedDevice = DisconnectedDeviceList.find(x => x.ALIAS === this.state.APIName);

        if(CheckboxList !== null && CheckboxList !== "" && CheckboxList !== undefined) 
        {
            CheckboxList.forEach(l => {

                var device = this.state.DeviceList.find(x => x.DeviceSerialNumber === l);
                SerialDevices.push(device.DeviceSerialNumber);
            })
        }     

        var Validate = this.ValidateSaveDisconnectedDevice();
        if (Validate === false) {
            return false;
        }

        this.setState({
            loadingDisconnectedDevice: true
        });

        var SerialDevicesResult  = SerialDevices.join(",");
        var result = APIService.SaveDisconnectedDevices(CompanyCode, email, UserName, Pass, MinHoursDisconnected, EmailsTo, EmailFrom,EmailPhone, SerialDevicesResult);

        result.then(function (data) {

            if(data.data === "OK") {

                that.setState({
                    loadingDisconnectedDevice: false
                });

                var newList = {
                    ALIAS: DisconnectedDevice.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: DisconnectedDevice.ID,
                    NAME: DisconnectedDevice.NAME,
                    VALUE: {
                        EasyApiUser: UserName,
                        EasyApiPassword: Pass,
                        MinHoursDisconnected: MinHoursDisconnected,
                        EmailsTo: EmailsTo,
                        EmailFrom: EmailFrom,
                        EmailPhone: EmailPhone,
                        SerialDevices: SerialDevicesResult,
                        Name: DisconnectedDevice.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }else if(data.data === "NoExist") {

                that.setState({
                    loadingDisconnectedDevice: false
                });
                toast.error("API Setting dosen't exist!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }else if(data.data === "Empty") {
                that.setState({
                    loadingDisconnectedDevice: false
                });
                toast.error("Not Exist!", {
                    className: {
                        opacity: 0.8
                    }
                });
            }
        }).catch((error) => {

            that.setState({
                loadingDisconnectedDevice: false,
            });
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });
    }

    onChange(e, code) {
        const options = this.state.checkboxOptions
        let index

        if (!options.find(x => x === code)) {
            options.push(code)
        }else {
            index = options.indexOf(code)
            options.splice(index, 1)
        }
        this.setState({ checkboxOptions: options }, console.log())
    }
    SelectedAll(e) {

        if (e.target.checked) {
            let optionChecked = [];
            this.state.DeviceList.forEach(l => {
                optionChecked.push(l.DeviceSerialNumber);
            })
            this.setState({ checkboxOptions: optionChecked })
        }
        else {
            this.setState({ checkboxOptions: [] })
        }
    }
    render() {

        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        let List =   this.state.DeviceList.map((item, index) =>{
                                                return (
                                                        <div key={index}>
                                                            <Checkbox
                                                                style={{ width: 25, height: 25 }}
                                                                checked={this.state.checkboxOptions.find(x => x === item.DeviceSerialNumber) !== undefined}
                                                                onChange={(e) => this.onChange(e, item.DeviceSerialNumber)}
                                                                value={item.DeviceSerialNumber}
                                                                color="primary"
                                                            /> 
                                                            <label>{item.DeviceLocationName}</label>
                                                        </div>                                                          
                                                );
                                                        
                                                });
     

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar />
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll' }}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Name</label>
                            </div>
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={this.state.APIName} readOnly />
                            </div>
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Disconnected Hours</label>
                            </div>
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="DisconnectedHours" id="DisconnectedHours" type="number" onChange={this.handleMinHoursDisconnected} value={this.state.MinHoursDisconnected} />
                            </div>
                        </div>
                        <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1 }} />
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Easy API User</label>
                            </div>
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apiuser" id="apiuser" type="text" onChange={this.handleApiUser} value={this.state.APIUser} />
                            </div>
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Easy API Password</label>
                            </div>
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apipass" id="apipass" type={this.state.type} onChange={this.handleApiPass} value={this.state.APIPass} />
                            </div>
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>
                                <Badge color="default" style={{ 'cursor': 'pointer' }} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>
                        </div>
                        <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1 }} />
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Emails Alert To(<span style={{color: 'red'}}>*</span>):</label>
                            </div>
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="EmailsTo" id="EmailsTo" type="text" onChange={this.handleEmailsTo} value={this.state.EmailsTo} />
                            </div>
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Email Alert From(<span style={{color: 'red'}}>*</span>):</label>
                            </div>
                            <div className="col-2">
                                <input type="text" style={{ 'marginTop': '10px' }} className="form-control" name="EmailFrom" id="EmailFrom" onChange={this.handleEmailFrom} value={this.state.EmailFrom} />
                            </div>
                        </div>
                        <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1 }} />
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>Devices</label>
                            </div>
                            <div className="col-2" style={{ marginRight: "100px" , paddingTop: '20px'}}>
                                {/* <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpUsername" id="FtpUsername" type="text" onChange={this.handleDevices}  value={ this.state.Devices}/> */}
                                <div style={{ "overflowY": "scroll", height: '200px' }}>
                                    <div className="">
                                        <div className="" >
                                            <Checkbox
                                                style={{ width: 25, height: 25 }}
                                                // checked={this.state.Selected}
                                                onChange={this.SelectedAll}
                                                //value={this.state.checkboxOptions}
                                                color="primary"
                                            />
                                            <label>All Devices</label>
                                        </div>                                       
                                        {
                                          <div style={{ paddingLeft: '15px'}}>
                                                 {List}
                                          </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px', 'fontWeight': 'bold' }}>T Support Phone(<span style={{color: 'red'}}>*</span>):</label>
                            </div>
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="EmailPhone" id="EmailPhone" type="text" onChange={this.handleEmailPhone} value={this.state.EmailPhone} />
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-2 offset-10" size="sm" >
                                <ClipLoader
                                    className={override}
                                    sizeUnit={"px"}
                                    size={30}
                                    color={'#33B5E5'}
                                    loading={this.state.loadingDisconnectedDevice}
                                />
                                {
                                    this.state.loadingDisconnectedDevice
                                        ?
                                        <Button color="info" tag="a" onClick={(e) => this.SaveDisconnectedDevice(e)} disabled>Save</Button>
                                        :
                                        <Button color="info" tag="a" onClick={(e) => this.SaveDisconnectedDevice(e)}>Save</Button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default DisconnectedDevice;


// WEBPACK FOOTER //
// ./src/APIComponent/DisconnectedDevice.jsx